<h2 mat-dialog-title>{{ titleLabel }}</h2>
<mat-dialog-content>
  <div class="feedback-content">
    <!-- Loading state -->
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="30"></mat-spinner>
        <p>{{ loadingLabel }}</p>
      </div>
    }

    <!-- Config not available -->
    @if (!loading && !isConfigAvailable) {
      <div class="error-container">
        <p>{{ configErrorMessage }}</p>
      </div>
    }

    <!-- Feedback form -->
    @if (!loading && isConfigAvailable) {
      <div>
        <!-- Header description -->
        @if (config?.header) {
          <div class="feedback-header">
            <h3>{{ config?.header }}</h3>
          </div>
        }
        @if (config?.headerDescription) {
          <div class="feedback-description">
            <p>{{ config?.headerDescription }}</p>
          </div>
        }
        <form [formGroup]="feedbackForm" class="feedback-form">
          <!-- Name field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ nameLabel }}</mat-label>
            <input matInput formControlName="name" required>
            @if (feedbackForm.get('name')?.hasError('required')) {
              <mat-error>
                {{ requiredError }}
              </mat-error>
            }
          </mat-form-field>
          <!-- Email field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ emailLabel }}</mat-label>
            <input matInput formControlName="email" type="email" required>
            @if (feedbackForm.get('email')?.hasError('required')) {
              <mat-error>
                {{ requiredError }}
              </mat-error>
            }
            @if (feedbackForm.get('email')?.hasError('email')) {
              <mat-error>
                {{ emailError }}
              </mat-error>
            }
          </mat-form-field>
          <!-- Subject field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ subjectLabel }}</mat-label>
            <input matInput formControlName="subject" required>
            @if (feedbackForm.get('subject')?.hasError('required')) {
              <mat-error>
                {{ requiredError }}
              </mat-error>
            }
          </mat-form-field>
          <!-- Context info (from detail view) -->
          @if (data?.context?.entries?.length) {
            <div class="feedback-context-info">
              <h4 i18n="@@feedback.context.title">Related Information</h4>
              @for (entry of data!.context!.entries; track entry.label) {
                <div class="context-entry">
                  <span class="context-label">{{ entry.label }}:</span>
                  <span class="context-value">{{ entry.value }}</span>
                </div>
              }
            </div>
          }
          <!-- Message field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ messageLabel }}</mat-label>
            <textarea matInput formControlName="message" rows="5" required
            [placeholder]="config?.messagePlaceholder || ''"></textarea>
            @if (feedbackForm.get('message')?.hasError('required')) {
              <mat-error>
                {{ requiredError }}
              </mat-error>
            }
          </mat-form-field>
          <!-- Attachment field (if enabled) -->
          @if (config?.attachmentEnabled) {
            <div class="attachment-section">
              <label class="attachment-label">{{ attachmentLabel }}</label>
              <div class="attachment-input">
                <input type="file" id="attachment" (change)="onFileSelected($event)" #fileInput>
                @if (selectedFile) {
                  <div class="selected-file">
                    <mat-icon>attach_file</mat-icon>
                    <span>{{ selectedFile.name }}</span>
                    <button mat-icon-button type="button" (click)="removeFile(); fileInput.value = ''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                }
              </div>
              @if (config?.maxAttachmentSize) {
                <mat-hint class="file-hint">
                  Max file size: {{ getMaxFileSizeFormatted() }}
                </mat-hint>
              }
              @if (fileError) {
                <div class="file-error">
                  {{ fileError }}
                </div>
              }
            </div>
          }
        </form>
        <!-- Bottom description -->
        @if (config?.bottomDescription) {
          <div class="feedback-bottom-description">
            <p>{{ config?.bottomDescription }}</p>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ cancelLabel }}</button>
  <button mat-raised-button color="primary"
    (click)="submit()"
    [disabled]="loading || submitting || !isConfigAvailable || feedbackForm.invalid">
    @if (submitting) {
      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
    }
    @if (!submitting) {
      <span>{{ submitLabel }}</span>
    }
  </button>
</mat-dialog-actions>

